import { render } from "./TemperatureChart.vue?vue&type=template&id=4421f228"
import script from "./TemperatureChart.vue?vue&type=script&lang=js"
export * from "./TemperatureChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__